import { z } from "zod";

const passwordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .regex(/[A-Z]/, "Password must contain an uppercase letter")
  .regex(/[a-z]/, "Password must contain a lowercase letter")
  .regex(/[0-9]/, "Password must contain a digit")
  .regex(/[^A-Za-z0-9]/, "Password must contain a special character");

export const signupSchema = z
  .object({
    companyName: z
      .string()
      .trim()
      .min(1, "Company name is required")
      .max(200, "Company name must be at most 200 characters"),
    managerName: z
      .string()
      .trim()
      .min(1, "Manager name is required")
      .max(200, "Manager name must be at most 200 characters"),
    email: z.string().trim().min(1, "Email is required").email("Invalid email address"),
    password: passwordSchema,
    confirmPassword: z.string().min(1, "Please confirm your password"),
    industry: z.string().max(100, "Industry must be at most 100 characters").optional(),
    website: z.string().max(255, "Website must be at most 255 characters").optional(),
    phone: z.string().max(20, "Phone must be at most 20 characters").optional(),
    termsAccepted: z.boolean().refine((val) => val, {
      message: "You must accept the terms and conditions",
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

export type SignupFormData = z.infer<typeof signupSchema>;
